import style from "./mainArticle1.module.scss";
import PeopleImage from "../../../assets/images/intro/People.png";
import { StrongTextStyle } from "../../../components/common/StyledCommonComponents";
import { Trans, useTranslation } from "react-i18next";

export default function Intro() {
  const { t } = useTranslation("aboutDcas");
  return (
    <section className={`${style.section6}`}>
      <div className={style.whiteContainer}></div>
      <div className={`${style.textArea}`}>
        <p className={`${style.introText}`}>
          <Trans t={t} i18nKey={"subtitle.line1"} components={[<StrongTextStyle />]} /> <br />
          <Trans t={t} i18nKey={"subtitle.line2"} components={[<StrongTextStyle />]} />
        </p>
      </div>
      <div style={{ textAlign: "center" }}>
        <img src={PeopleImage} alt={""} className={`${style.peopleImage}`} />
      </div>
      <div className={`${style.bottomTextArea}`}>
        <p className={`${style.bottomText}`}>{t("bottomDesc.line1")}</p>
        <p className={`${style.bestText}`}>
          <span className={`${style.underline}`}>{t("bottomDesc.highlightText")}</span>
          {t("bottomDesc.line2")}
        </p>
      </div>
    </section>
  );
}
